import React, { Component } from "react"
import { Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import LabServiceRegulatoryModesGetObservable from "../../../api/LabService/LabServiceRegulatoryModesGet"

export interface PersonnelRegulatoryModeProps {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    selected?: number
}

interface PersonnelRegulatoryModeState {
    data?: RegulatoryMode[]
}

export default class PersonnelRegulatoryMode extends Component<PersonnelRegulatoryModeProps, PersonnelRegulatoryModeState> {
    state: PersonnelRegulatoryModeState = { data: [] }
    loadSubscription?: Subscription

    componentDidMount() {
        this.loadSubscription = LabServiceRegulatoryModesGetObservable().subscribe(
            data => this.setState({ data: data }),
            error => toast.error(error.message)
        )
    }

    componentWillUnmount() {
        this.loadSubscription && this.loadSubscription.unsubscribe()
    }

    render = () => (
        <Form.Control as="select" name="RegulatoryModeID" onChange={this.props.onChange} value={this.props.selected || ""}>
            <option value="">Select Mode</option>
            {this.state.data?.map((item: any, key: number) => <option key={key} value={item.RegulatoryModeID}>{item.Name}</option>)}
        </Form.Control>
    );
}
